import React from 'react';

import { logOutUser } from 'src/utils/constants'

const Profile = React.lazy(() => import('../views/profile/Profile'));

const Dashboard = React.lazy(() => import('../views/dashboard/Dashboard'));

// Masters
const UserMaster = React.lazy(() => import('../views/userMaster/UserMaster'));
const UserEntry = React.lazy(() => import('../views/userMaster/UserEntry'));
const FindUsers = React.lazy(() => import('../views/userMaster/FindUsers'));

const VendorMaster = React.lazy(() => import('../views/vendorMaster/VendorMaster'));
const VendorEntry = React.lazy(() => import('../views/vendorMaster/VendorEntry'));

const VehicleTypeMaster = React.lazy(() => import('../views/vehicleTypeMaster/VehicleTypeMaster'));
const VehicleTypeEntry = React.lazy(() => import('../views/vehicleTypeMaster/VehicleTypeEntry'));

const VehicleMakeMaster = React.lazy(() => import('../views/vehicleMakeMaster/VehicleMakeMaster'));
const VehicleMakeEntry = React.lazy(() => import('../views/vehicleMakeMaster/VehicleMakeEntry'));

const CustomerMaster = React.lazy(() => import('../views/customerMaster/CustomerMaster'));
const CustomerEntry = React.lazy(() => import('../views/customerMaster/CustomerEntry'));

const ServiceLocation = React.lazy(() => import('../views/serviceLocationMaster/ServiceLocationMaster'));
const ServiceLocationEntry = React.lazy(() => import('../views/serviceLocationMaster/ServiceLocationEntry'));

const BookingMaster = React.lazy(() => import('../views/bookings/BookingMaster'));
const BookingEntry = React.lazy(() => import('../views/bookings/BookingEntry'));
const PreviewBookings = React.lazy(() => import('../views/bookings/PreviewBookings'));
const CustomerBookingMaster = React.lazy(() => import('../views/bookings/customerBookings/CustomerBookingMaster'));
const CustomerAddBooking = React.lazy(() => import('../views/bookings/customerBookings/CustomerAddBooking'));
const VendorBookingMaster = React.lazy(() => import('../views/bookings/vendorBookings/VendorBookingMaster'));
const ViewBooking = React.lazy(() => import('../views/bookings/ViewBooking'));
const ChangeRequests = React.lazy(() => import('../views/bookings/changeRequests/ChangeRequests'));

const ProformaInvoiceMaster = React.lazy(() => import('../views/proformaInvoiceMaster/ProformaInvoiceMaster'));
const ProformaInvoiceEntry = React.lazy(() => import('../views/proformaInvoiceMaster/ProformaInvoiceEntry'));

const VendorInvoiceMaster = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceMaster'));
const VendorInvoiceGenerate = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceGenerate'));
const VendorInvoiceEntry = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceEntry'));

const InvoiceMaster = React.lazy(() => import('../views/invoiceMaster/InvoiceMaster'));
const InvoiceGenerate = React.lazy(() => import('../views/invoiceMaster/InvoiceGenerate'));
const InvoiceEntry = React.lazy(() => import('../views/invoiceMaster/InvoiceEntry'));
const InvoiceCustomerMaster = React.lazy(() => import('../views/invoiceMaster/customerInvoice/InvoiceCustomerMaster'));
const InvoiceViewDetails = React.lazy(() => import('../views/invoiceMaster/customerInvoice/InvoiceViewDetails'));

const PackageMaster = React.lazy(() => import('../views/packageMaster/packageMaster'));
const PackageEntry = React.lazy(() => import('../views/packageMaster/packageEntry'));

const BranchMaster = React.lazy(() => import('../views/branchMaster/BranchMaster'));
const BranchEntry = React.lazy(() => import('../views/branchMaster/BranchEntry'));

const VehicleExpenseMaster = React.lazy(() => import('../views/fuelMaster/FuelMaster'));
const VehicleExpenseEntry = React.lazy(() => import('../views/fuelMaster/FuelEntry'));

// Reports
const TripsReport = React.lazy(() => import('../views/trips/TripsReport'));
const SalesReport = React.lazy(() => import('../views/salesReport/SalesReport'));
const BillCoverReport = React.lazy(() => import('../views/billCoverReport/BillCoverReport'));
const AuditReport = React.lazy(() => import('../views/auditReport/AuditReport'));
const DocumentExpiryReport = React.lazy(() => import('../views/documentExpiryReport/DocumentExpiryReport'));
const MonthlyTurnOverReport = React.lazy(() => import('../views/monthlyTurnOverReport/MonthlyTurnOverReport'));
const ExpiryAgreementReport = React.lazy(() => import('../views/expiryAgreementReport/ExpiryAgreementReport'));
const FleetReport = React.lazy(() => import('../views/fleetReportMaster/FleetReportMaster'));
const VehicleWiseSalesReport = React.lazy(() => import('../views/vehicleWiseSalesReport/VehicleWiseSalesReport'));
const VehicleProductivityReport = React.lazy(() => import('../views/vehicleProductivityReport/VehicleProductivityReport'));
const ServiceDueReport = React.lazy(() => import('../views/serviceDueReport/ServiceDueReport'));
const ProfitLossReport = React.lazy(() => import('../views/profitLossReport/ProfitLossReport'));

// Others
const RoleManagement = React.lazy(() => import('../views/roleManagement/RoleManagement'));

// My Accounts Details
const AccountDetails = React.lazy(() => import('../views/myAccounts/accountDetails/AccountDetails'));

// My Account KYC
const AccountKYC = React.lazy(() => import('../views/myAccounts/accountKYC/AccountKYC'));

// My Account Department
const AccontDepartment = React.lazy(() => import('../views/myAccounts/accountDepartment/AccountDepartment'));
const AccontDepartmentDetails = React.lazy(() => import('../views/myAccounts/accountDepartment/AccountDepartmentDetails'));
const AccountCreateDepartment = React.lazy(() => import('../views/myAccounts/accountDepartment/AccountCreateDepartment'));

// My Account Users
const AccountUsers = React.lazy(() => import('../views/myAccounts/accountUsers/AccountUsers'));
const AccountUserDetails = React.lazy(() => import('../views/myAccounts/accountUsers/AccountUserDetails'));
const AccountCreateUser = React.lazy(() => import('../views/myAccounts/accountUsers/AccountCreateUser'));

// My Account Vehicles
const AccountVehicles = React.lazy(() => import('../views/myAccounts/accountVehicles/AccountVehicles'));
const AccountVehicleDetails = React.lazy(() => import('../views/myAccounts/accountVehicles/AccountVehicleDetails'));
const AccountCreateVehicle = React.lazy(() => import('../views/myAccounts/accountVehicles/AccountCreateVehicle'));

//My Account Drivers
const AccountDrivers = React.lazy(() => import('../views/myAccounts/accountDrivers/AccountDrivers'));
const AccountDriverDetails = React.lazy(() => import('../views/myAccounts/accountDrivers/AccountDriverDetails'));
const AccountCreateDriver = React.lazy(() => import('../views/myAccounts/accountDrivers/AccountCreateDriver'));

//My Account Contact
const AccountContact = React.lazy(() => import('../views/myAccounts/accountContact/AccountContact'));
const AccountContactDetails = React.lazy(() => import('../views/myAccounts/accountContact/AccountContactDetails'));

//My Account Contracts
const AccountContracts = React.lazy(() => import('../views/myAccounts/accountContracts/AccountContracts'));
const AccountContractDetails = React.lazy(() => import('../views/myAccounts/accountContracts/AccountContractDetails'));

//My Account GST
const AccountGST = React.lazy(() => import('../views/myAccounts/accountGST/AccountGST'));

// Credit Notes
const CreditNoteList = React.lazy(() => import('../views/creditNotes/CreditNoteList'));
const CreditNoteGenerate = React.lazy(() => import('../views/creditNotes/CreditNoteGenerate'));
const CreditNoteEntry = React.lazy(() => import('../views/creditNotes/CreditNoteEntry'));

// Debit Notes
const DebitNoteList = React.lazy(() => import('../views/debitNotes/DebitNoteList'));
const DebitNoteGenerate = React.lazy(() => import('../views/debitNotes/DebitNoteGenerate'));
const DebitNoteEntry = React.lazy(() => import('../views/debitNotes/DebitNoteEntry'));

// Settings
// User Preferences
const UserPreferences = React.lazy(() => import('../views/settings/UserPreferences'));

const Logout = () => {
  React.useEffect(() => {
    logOutUser();
  }, []);

  return null;
};

const routes = [
  { path: '/profile', name: 'Profile', element: Profile },

  { path: '/dashboard', name: 'Dashboard', element: Dashboard },

  { path: '/service-location', name: 'Service Location', element: ServiceLocation },
  { path: '/service-location/entry', name: 'Entry', element: ServiceLocationEntry },
  { path: '/service-location/entry/:id', name: 'Entry', element: ServiceLocationEntry },

  { path: '/vehicle-type', name: 'Vehicle Type', element: VehicleTypeMaster },
  { path: '/vehicle-type/entry', name: 'Entry', element: VehicleTypeEntry },
  { path: '/vehicle-type/entry/:id', name: 'Entry', element: VehicleTypeEntry },

  { path: '/vehicle-make', name: 'Vehicle Make', element: VehicleMakeMaster },
  { path: '/vehicle-make/entry', name: 'Entry', element: VehicleMakeEntry },
  { path: '/vehicle-make/entry/:id', name: 'Entry', element: VehicleMakeEntry },

  { path: '/vehicle-expense', name: 'Vehicle Expense', element: VehicleExpenseMaster },
  { path: '/vehicle-expense/entry', name: 'Entry', element: VehicleExpenseEntry },
  { path: '/vehicle-expense/entry/:id', name: 'Entry', element: VehicleExpenseEntry },

  { path: '/vendors', name: 'Vendors', element: VendorMaster },
  { path: '/vendors/entry', name: 'Entry', element: VendorEntry },
  { path: '/vendors/entry/:id', name: 'Entry', element: VendorEntry },

  { path: '/customers', name: 'Customers', element: CustomerMaster },
  { path: '/customers/entry', name: 'Entry', element: CustomerEntry },
  { path: '/customers/entry/:id', name: 'Entry', element: CustomerEntry },

  { path: '/bookings', name: 'Bookings', element: BookingMaster },
  { path: '/bookings/entry', name: 'Entry', element: BookingEntry },
  { path: '/bookings/entry/:id', name: 'Entry', element: BookingEntry },
  { path: '/bookings/preview', name: 'Entry', element: PreviewBookings },
  { path: '/bookings/change-requests', name: 'Change Requests', element: ChangeRequests },
  { path: '/customer-bookings', name: 'Bookings', element: CustomerBookingMaster },
  { path: '/customer-bookings/details/:id', name: 'Details', element: ViewBooking },
  { path: '/customer-bookings/entry', name: 'Entry', element: CustomerAddBooking },
  { path: '/vendor-bookings', name: 'Bookings', element: VendorBookingMaster },
  { path: '/vendor-bookings/details/:id', name: 'Details', element: ViewBooking },

  { path: '/proforma-invoices', name: 'Proforma Invoice', element: ProformaInvoiceMaster },
  { path: '/proforma-invoices/entry', name: 'Entry', element: ProformaInvoiceEntry },
  { path: '/proforma-invoices/entry/:id', name: 'Entry', element: ProformaInvoiceEntry },

  { path: '/vendor/invoices', name: 'Vendor Invoice', element: VendorInvoiceMaster },
  { path: '/vendor/invoices/generate', name: 'Vendor Invoice', element: VendorInvoiceGenerate },
  { path: '/vendor/invoices/entry', name: 'Entry', element: VendorInvoiceEntry },
  { path: '/vendor/invoices/entry/:id', name: 'Entry', element: VendorInvoiceEntry },

  { path: '/invoices', name: 'Invoice', element: InvoiceMaster },
  { path: '/invoices/generate', name: 'Invoice', element: InvoiceGenerate },
  { path: '/invoices/entry', name: 'Entry', element: InvoiceEntry },
  { path: '/invoices/entry/:id', name: 'Entry', element: InvoiceEntry },
  { path: '/invoices/customer', name: 'Invoice', element: InvoiceCustomerMaster },
  { path: '/invoices/view-details/:id', name: 'Details', element: InvoiceViewDetails },

  { path: '/branch', name: 'Branch', element: BranchMaster },
  { path: '/branch/entry', name: 'Entry', element: BranchEntry },
  { path: '/branch/entry/:id', name: 'Entry', element: BranchEntry },

  { path: '/credit-note', name: 'Credit Notes', element: CreditNoteList },
  { path: '/credit-note/generate', name: 'Credit Notes', element: CreditNoteGenerate },
  { path: '/credit-note/entry', name: 'Entry', element: CreditNoteEntry },
  { path: '/credit-note/entry/:id', name: 'Details', element: CreditNoteEntry },

  { path: '/debit-note', name: 'Debit Notes', element: DebitNoteList },
  { path: '/debit-note/generate', name: 'Debit Notes', element: DebitNoteGenerate },
  { path: '/debit-note/entry', name: 'Entry', element: DebitNoteEntry },
  { path: '/debit-note/entry/:id', name: 'Entry', element: DebitNoteEntry },

  { path: '/package', name: 'Package', element: PackageMaster },
  { path: '/package/entry', name: 'Package', element: PackageEntry },
  { path: '/package/entry/:id', name: 'Package', element: PackageEntry },

  { path: '/report/trips', name: 'Trips', element: TripsReport },
  { path: '/report/sales', name: 'Sales Report', element: SalesReport },
  { path: '/report/bill-cover', name: 'Bill Cover Report', element: BillCoverReport },
  { path: '/report/audit', name: 'Audit Report', element: AuditReport },
  { path: '/report/profit-loss', name: 'Profit/Loss Reports', element: ProfitLossReport },
  { path: '/report/doc-expiry', name: 'Document Expiry Report', element: DocumentExpiryReport },
  { path: '/report/monthy-turnover', name: 'Monthly Turn Over Report', element: MonthlyTurnOverReport },
  { path: '/report/agreement-expiry', name: 'Expiry Agreement Reports', element: ExpiryAgreementReport },
  { path: '/report/fleet', name: 'Fleet Reports', element: FleetReport },
  { path: '/report/vehicle-wise-sales', name: 'Vehicle Wise Sales Reports', element: VehicleWiseSalesReport },
  { path: '/report/vehicle-productivity', name: 'Vehicle Productivity Reports', element: VehicleProductivityReport },
  { path: '/report/service-due', name: 'Service Due Report', element: ServiceDueReport },

  { path: '/find-users', name: 'Find Users', element: FindUsers },

  { path: '/users', name: 'Users', element: UserMaster },
  { path: '/users/entry', name: 'Entry', element: UserEntry },
  { path: '/users/entry/:id', name: 'Entry', element: UserEntry },

  { path: '/roles', name: 'Role Management', element: RoleManagement },

  { path: '/account/details', name: 'Details', element: AccountDetails },

  { path: '/account/kyc', name: 'KYC', element: AccountKYC },

  { path: '/account/department', name: 'Department', element: AccontDepartment },
  { path: '/account/department/details', name: 'Details', element: AccontDepartmentDetails },
  { path: '/account/department/entry', name: 'Entry', element: AccountCreateDepartment },

  { path: '/account/users', name: 'Users', element: AccountUsers },
  { path: '/account/users/details', name: 'Details', element: AccountUserDetails },
  { path: '/account/users/entry', name: 'Entry', element: AccountCreateUser },

  { path: '/account/vehicles', name: 'Vehicles', element: AccountVehicles },
  { path: '/account/vehicles/details', name: 'Details', element: AccountVehicleDetails },
  { path: '/account/vehicles/entry', name: 'Entry', element: AccountCreateVehicle },

  { path: '/account/drivers', name: 'Drivers', element: AccountDrivers },
  { path: '/account/drivers/details', name: 'Details', element: AccountDriverDetails },
  { path: '/account/drivers/entry', name: 'Entry', element: AccountCreateDriver },

  { path: '/account/contact', name: 'Contact', element: AccountContact },
  { path: '/account/contact/details', name: 'Details', element: AccountContactDetails },

  { path: '/account/contracts', name: 'Contracts', element: AccountContracts },
  { path: '/account/contracts/details', name: 'Details', element: AccountContractDetails },

  { path: '/account/gst', name: 'GST', element: AccountGST },

  { path: '/settings/preferences', name: "User Preferences", element: UserPreferences },

  { path: '/account/logout', name: 'Logout', element: Logout },
]

export default routes
